<div class="modal__content cookie">
    <div class="cookie__age">
        <div class="cookie__age-icon">
            18+
        </div>
        <div class="cookie__age-text">
            <p>{{ $t('modals.cookie18.age') }}</p>
        </div>
    </div>

    <div class="cookie__text" v-if="!manageCookies">
        <h3>{{ $t('modals.cookie18.title') }}</h3>
        <p v-html="$t('modals.cookie18.content')"></p>

        <div class="form__group-row">
            <button class="btn btn" @click="accept(true)">{{ $t('modals.cookie18.accept') }}</button>
        </div>

        <p>
            <a class="link" @click="manageCookies = !manageCookies">{{ $t('modals.cookie18.managecookies') }}</a>
            <span class="rowpad">{{ $t('modals.cookie18.or') }}</span>
            <a class="link" @click="redirect()">{{ $t('modals.cookie18.rejectcookies') }}</a>
        </p>
    </div>

    <div class="cookie__text" v-if="manageCookies">
        <h3>{{ $t('modals.cookie18.managecookies') }}</h3>
        <p v-html="$t('modals.cookie18.managecookies-desc')"></p>
        <div class="cookie__toggles">

            <div class="cookie__toggles-toggle form__group" v-for="(cookie, key) in toggles">
                <span>
                    <label class="label toggle light" :for="cookie.name" :class="{'disabled': key === 0 }">
                        <input type="checkbox" :id="cookie.name" class="toggle__input" v-model="cookie.value" />
                        <div class="toggle__control"></div>
                    </label>
                </span>
                <span>
                    <h2>{{ $t('modals.cookie18.'+ cookie.name +'-cookies') }}</h2>
                    <p class="nomar" v-html="$t('modals.cookie18.'+ cookie.name + '-cookies-des')"></p>
                </span>
            </div>
        </div>
        <p></p>
        <div class="form__group-row">
            <a class="link mr" @click="accept(false)">{{ $t('modals.cookie18.confirm') }}</a>
            <button class="btn btn ml" @click="accept(true)">{{ $t('modals.cookie18.acceptall') }}</button>
        </div>
    </div>

</div>
 